module.exports = __webpack_public_path__ + "static/media/mobile.ad67e0b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/TeamBox/img/mobile.svg
// module id = 75
// module chunks = 0